import type { TaskActionItem } from "@/services/api/agentic-v2";

/** Prefer live summary; fall back to the task description when nothing new to show. */
export function taskCardDescription(task: TaskActionItem): string | null {
  const summary = task.latest_summary?.trim();
  if (summary) return summary;
  const description = task.definition_of_done?.trim();
  if (description) return description;
  return null;
}
